import { useContext, useState } from 'react';

import { SettingsManager, Localization } from '@viamap/viamap2-common';
import { ApplicationStateContext, Feature } from 'src/states/ApplicationState';
import { FRPContext } from './FRPState';
import { ManageDocuments } from 'src/components/ManageDocuments';
import { InfoMessageModal } from 'src/components/AppMessagesComponents';
import { GlassCheckbox } from 'src/components/MitGlassComponents';

export const FRPDocuments = (props: {
  callbackOnClose: () => void;
}) => {

  let { state: frpState } = useContext(FRPContext);
  const { hasAccessToFeature } = useContext(ApplicationStateContext);
  const [includeParentDocuments, setIncludeParentDocuments] = useState(false);



  let bucket = SettingsManager.getSystemSetting("frp.documentStorageS3Bucket");
  let path = SettingsManager.getSystemSetting("frp.documentStorageS3Path");
  let projectId = frpState.selectedProject?.id ?? "unknown_project";
  let elementId = frpState.selectedElementIds.length === 1 ? frpState.selectedElementIds[0] : "";
  let element = elementId != "" ? frpState.elements[elementId] : undefined;
  let elementsToInclude = [elementId];

  // add parent elements to the list
  let elm = elementId;
  while (elm && elm !== "") {
    let theElement = frpState.elements[elm];
    if (theElement?.refElementId != undefined && !elementsToInclude.includes(theElement.refElementId)) {
      elementsToInclude.push(theElement.refElementId);
    }
    elm = theElement?.refElementId!;
  }

  if (frpState.selectedElementIds.length > 1) {
    return <InfoMessageModal message={Localization.getText("Please select exactly one element to manage documents.")} onDismiss={() => props.callbackOnClose()} />
  }

  function frpCreateDocumentPrefix(path: string, projectId: string, elementId: string): string {
    if (elementId && elementId.length > 0) {
      return `${path}${projectId}/${elementId}/`;
    } else {
      return `${path}${projectId}/`;
    }
  }

  let prefix = frpCreateDocumentPrefix(path, projectId, elementId);
  const parentElementIds = elementsToInclude.filter(id => id && id !== elementId);

  const additionalPaths = includeParentDocuments
    ? parentElementIds.map(parentId => ({
      path: frpCreateDocumentPrefix(path, projectId, parentId),
    }))
    : [];

  const showParentToggle = parentElementIds.length > 0;

  return (
    <ManageDocuments
      show={true}
      callbackOnClose={() => props.callbackOnClose()}
      projectName={frpState.selectedProject?.name + (elementId ? " - " + (element?.name ?? elementId) : "") || "Unknown Project"}
      projectId={frpState.selectedProject?.id}
      bucket={bucket}
      path={prefix}
      additionalPaths={additionalPaths}
      toolbarContent={
        showParentToggle ? (
          <GlassCheckbox
            checked={includeParentDocuments}
            onClick={(e, val) => { setIncludeParentDocuments(val); }}
          >
            {Localization.getText("Show inherited documents")}
          </GlassCheckbox>
        ) : null
      }
      resolveElementName={(elementId: string) => frpState.elements[elementId]?.name || elementId}
      uploadAvailable={hasAccessToFeature(Feature.FRPProjectWrite)}
      deleteAvailable={hasAccessToFeature(Feature.FRPProjectWrite)}
      openAvailable={false}
      downloadAvailable={hasAccessToFeature(Feature.FRPProjectRead)}
      copyLinkAvailable={false}
      createUniqueFileName={false}
      linksAvailable={true}
    />
  );
}



